import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Legal({ page }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page.title]);

  return (
    <div className="min-h-screen bg-[#F4F0E9]" data-testid="legal-page">
      <Header />
      <main className="pt-[74px]">
        <section className="mx-auto max-w-[860px] px-5 py-20 lg:px-8 lg:py-24">
          <h1 className="font-serifDisplay text-[38px] leading-tight text-[#26241F] lg:text-[52px]">{page.title}</h1>
          <p className="mt-5 text-[16px] leading-relaxed text-[#6e6a62]">{page.intro}</p>
          <div className="mt-12 space-y-10">
            {page.sections.map((s) => (
              <article key={s.h}>
                <h2 className="text-[19px] font-semibold text-[#26241F]">{s.h}</h2>
                {s.p.map((t) => (
                  <p key={t} className="mt-2 text-[15px] leading-relaxed text-[#6e6a62]">{t}</p>
                ))}
              </article>
            ))}
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}
